import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getCountryCode,
  getCountryFilterEnabled,
  getDefaultCountryFilter,
  getOtherCountriesFilter
} from '../redux/config'
import { DomainType, DomainsActions, getDomain, isDomainLoading } from '../redux/domains'
import { RootState } from '../redux/types'

export const useCountries = (skip?: boolean) => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const { language } = i18n

  const countryFilterEnabled = useSelector(getCountryFilterEnabled)
  const defaultCountry = useSelector(getDefaultCountryFilter)
  const domainCode = useSelector(getCountryCode)
  const otherCountries = useSelector(getOtherCountriesFilter)

  const countriesLoading = useSelector((state: RootState) => isDomainLoading(state, { domain: DomainType.Country }))
  const countryDomain = useSelector((state: RootState) => getDomain(state, { domain: DomainType.Country, language }))
  useEffect(() => {
    if ((!countryFilterEnabled || !defaultCountry) && !countriesLoading && !countryDomain && !skip) {
      dispatch(
        DomainsActions.loadDomains({
          domainTypes: [DomainType.Country],
          language
        })
      )
    }
  }, [dispatch, language, countryFilterEnabled, defaultCountry, countriesLoading, countryDomain, skip])

  const countries = useMemo(
    () =>
      countryFilterEnabled && defaultCountry
        ? // when regional offering is enabled
          _.map(_.compact(_.concat(defaultCountry, otherCountries)), c => ({ code: c.countryCode, label: c.label }))
        : // when regional offering is disabled
          _.map(_.compact([_.find(countryDomain, cd => cd.code === domainCode)]), cd => ({
            code: cd.code,
            label: cd.description
          })),
    [countryDomain, countryFilterEnabled, defaultCountry, domainCode, otherCountries]
  )

  return { countries, countriesLoading }
}
